import { Component } from 'react';
import { connect } from 'react-redux';

import { RootState } from '../..';
import * as AppService from '../../../../common/services/app/Service';
import { ConfigProp, IsReadyToRenderProp, RenderPropWithProps } from '../../../../common/types/prop-types/common';
import { config } from '../../../common/';
import { AppThunkDispatch } from '../../../common/types';

export interface BaseLayoutProps extends IsReadyToRenderProp, ConfigProp { }

export interface BaseLayoutContainerProps { }

interface ReduxDispatchProps {
    appServiceActions: AppService.ServiceActions;
}

class BaseLayoutContainer extends Component<BaseLayoutContainerProps & ReduxDispatchProps & RenderPropWithProps<BaseLayoutProps>> {
    public isReadyToRender(): boolean {
        return true;
    }

    public async componentDidMount() {
        await this.props.appServiceActions.loadPolicies();
        await this.props.appServiceActions.loadLookupValues();
    }

    public render() {
        const newProps: BaseLayoutProps = {
            isReadyToRender: this.isReadyToRender(),
            config,
        };
        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: RootState) => ({});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    appServiceActions: AppService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseLayoutContainer);
